<template>
  <v-sheet>
    <assessment-view :userId="parseInt(userId)"></assessment-view>
  </v-sheet>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import AssessmentView from "@/containers/assessments/AssessmentView"
import { mapGetters } from "vuex"
import eventMixin from "@/mixins/eventMixin"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [titleMixin, eventMixin],
  components: { AssessmentView },
  data: function() {
    return {
      title: "User Assessments"
    }
  },
  computed: {
    userId: {
      get() {
        return this.$store.state.globals.menteeId
      },
      set(value) {
        this.$store.commit("globals/setMenteeId", value)
      }
    },
    ...mapGetters("assessments", ["getAssessments"]),
    assessments() {
      // TODO: The assessments should be filtered by userId!!!
      return this.getAssessments
    }
  },
  updated() {
    this.$store.dispatch("assessments/assessmentsByUserId", {
      userId: this.userId
    })
  },
  created() {
    if (this.userId == 0) {
      let id = this.$route.params.id
      this.userId = id
    }

    if (this.userId > 0) {
      this.$store.dispatch("assessments/assessmentsByUserId", {
        userId: this.userId
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id
      this.$store.dispatch("assessments/assessmentsByUserId", {
        userId: this.userId
      })
    }
    next()
  },
  methods: {
    setAssessmentLink(el) {
      return {
        name: "assessmentView",
        params: { id: el.id }
      }
    }
  }
}
</script>
